<script lang="ts">
  import Page from '../Page.svelte';
  import Scroller from '../Scroller.svelte';
  import StatsWidgets from '../stats/StatsWidgets.svelte';

  export let params: { project: string };
</script>

<Page>
  <Scroller>
    <StatsWidgets project={params.project} />
  </Scroller>
</Page>
